export default "__VITE_ASSET__GVhJ7y1B__"